export default [
  {
    name: 'divider',
    component_path: 'modules/templates/blocks/TemplateDivider',
  }
]